(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[207],{

/***/ 85115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(99165),__webpack_require__(29891),__webpack_require__(90005),__webpack_require__(27378)):0}(this,function(e,t,r,a,o){function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=/*#__PURE__*/i(a),n=/*#__PURE__*/i(o);function d(){return d=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)({}).hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e},d.apply(null,arguments)}var s,c,u={sidenav:"_-zgZI","drawer-right":"_UAGtt","drawer-bottom":"_NHhut","drawer-right-open":"_OjYvl","slide-in-from-right":"_eBehV","drawer-right-close":"_Ij2ry","slide-out-to-right":"_mNHZJ","drawer-bottom-open":"_eV3Ey","slide-in-from-bottom":"_C4m-z","drawer-bottom-close":"_EX5cn","slide-out-to-bottom":"_soS-X"};!function(e){e["1/2"]="w-1/2",e["1/3"]="w-1/3",e["1/4"]="w-1/4",e["1/5"]="w-1/5",e["1/6"]="w-1/6",e["2/3"]="w-2/3",e["3/4"]="w-3/4",e["4/5"]="w-4/5",e.full="w-full"}(s||(s={})),function(e){e["1/2"]="h-1/2",e["1/3"]="h-1/3",e["1/4"]="h-1/4",e["1/5"]="h-1/5",e["1/6"]="h-1/6",e["2/3"]="h-2/3",e["3/4"]="h-3/4",e["4/5"]="h-4/5",e.full="h-full"}(c||(c={})),e.Drawer=function(e){var a,i=e.direction,f=e.isOpen,w=e.children,h=e.onCloseCallBack,m=e.classNames,v=void 0===m?"":m,y=e.height,g=void 0===y?"1/3":y,b=e.width,p=void 0===b?"1/4":b,_=e.icon,O=void 0===_?n.default.createElement("span",{className:"icon-clear text-grey-900 text-s-20 font-bold"}):_,x=e.hideIcon,E=void 0!==x&&x,j=e.closeOnClickOverlay,C=void 0!==j&&j,N=e.animationDuration,D=void 0===N?500:N,k=e.minWidth,q=void 0===k?350:k,I=e.top,L=void 0===I?"":I,P=o.useRef(null),z={"overlay-right":f?u["drawer-right-open"]:u["drawer-right-close"],"overlay-bottom":f?u["drawer-bottom-open"]:u["drawer-bottom-close"]},B=l.default(((a={})[u["drawer-"+i]]=!0,a[u.sidenav]=!0,a[""+v]=v,a[c[g]]="bottom"===i&&g,a[s[p]]="right"===i&&p,a[z["overlay-"+i]]=!0,a));return n.default.createElement(r.Portal,{selector:"drawer-portal"},n.default.createElement(t.Overlay,{ref:P,onClick:function(e){e.target===P.current&&C&&h()},isOverlay:f,animationDuration:D,top:L},n.default.createElement("div",{style:d({animationDuration:D+"ms"},"right"===i?{minWidth:q}:{},L?{top:L}:{}),"data-testid":"drawer",className:B+" transition"},n.default.createElement("div",{"data-testid":"drawer-close-icon",className:"cursor-pointer absolute top-4 left-4",onClick:function(){h()}},!E&&O),w)))}});


/***/ }),

/***/ 75049:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(27378),__webpack_require__(95844)):0}(this,function(e,t,a){function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=/*#__PURE__*/r(t),i=a.useCreateCtx(),l=i[0],d=i[1];function o(){return o=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)({}).hasOwnProperty.call(a,r)&&(e[r]=a[r])}return e},o.apply(null,arguments)}var u=function(e,t){switch(t.type){case"values":var a,r=o({},e.errors);return delete r[t.payload.updatedField],o({},e,{values:o({},e.values,(a={},a[t.payload.updatedField]=t.payload.value||"",a)),errors:o({},r)});case"errors":var n,i,l;return o({},e,{errors:o({},e.errors,(n={},n[t.payload.updatedField]=t.payload.error||"",n)),valid:o({},e.valid,(i={},i[t.payload.updatedField]=!1,i)),values:o({},e.values,(l={},l[t.payload.updatedField]=t.payload.value||"",l))});case"touched":var d;return o({},e,{touched:o({},e.touched,(d={},d[t.payload.updatedField]=!0,d))});case"dirty":var u;return o({},e,{dirty:o({},e.dirty,(u={},u[t.payload.updatedField]=!!t.payload.value,u))});case"valid":var s;return o({},e,{valid:o({},e.valid,(s={},s[t.payload.updatedField]=!!t.payload.isValid,s))});case"validator":var p;return o({},e,{validator:o({},e.validator,(p={},p[t.payload.updatedField]=t.payload.validator||[],p))});case"pipes":var c;return o({},e,{pipes:o({},e.pipes,(c={},c[t.payload.updatedField]=t.payload.pipes||[],c))});default:return e}},s=n.default.memo(function(e){var a=e.children,r=t.useReducer(u,{values:e.initialValues||{},errors:{},touched:{},dirty:{},valid:{},validator:{},pipes:{}}),i=r[0],l=r[1],o=function(e){var t=e.value,a=i.pipes[e.updatedField];return a&&a.length&&a.forEach(function(e){t=e(t)}),l({type:"values",payload:{updatedField:e.updatedField,value:t}})},s=function(e){return l({type:"errors",payload:e})},p=function(e){return l({type:"valid",payload:e})},c=function(e,t){var a=i.validator[e];if(a)for(var r=0;r<a.length;r++){var n=(0,a[r])(t,i.touched[e]);if(n&&n.msg)return n}return null},f=t.useMemo(function(){var e=Object.values(i.valid);return!(!e||!e.length)&&Object.values(i.valid).every(function(e){return!!e})},[i.valid]);return n.default.createElement(d,{value:{isFormValid:f,formState:i,setValues:o,setErrors:s,setTocuhed:function(e){return l({type:"touched",payload:e})},setDirty:function(e){return l({type:"dirty",payload:e})},setValidControl:function(e,t){var a=c(e,t);a&&a.msg?s({updatedField:e,error:a.msg,value:t}):(p({updatedField:e,isValid:!0}),o({updatedField:e,value:t}))},setFormFieldAsValid:p,setValidatorFn:function(e){return l({type:"validator",payload:e})},checkValidity:c,setPipesFn:function(e){return l({type:"pipes",payload:e})}}},a)}),p=n.default.memo(function(e){return n.default.createElement("div",{className:e.className+" relative"},e.children)}),c=function(e){if(e){var t=new Date(String(e));if(!(t instanceof Date)||isNaN(t.getTime())||t.getTime()<0)return{msg:"Not a valid date"}}return{msg:"Not a valid date"}},f=function(){var e=l();return{formState:e.formState,setValidControl:e.setValidControl,isFormValid:e.isFormValid,setErrors:e.setErrors}},v=n.default.memo(function(e){var a=t.useState(!1),r=a[0],i=a[1],l=f();return t.useEffect(function(){l.formState.errors[e.id]&&i(!0)},[l.formState.errors[e.id]]),n.default.createElement("p",{className:"h-5 text-sm absolute "+(l.formState.errors[e.id]&&"text-red-500"),id:e.id+"-error",style:{zIndex:0}},r?l.formState.errors[e.id]:"")});e.FormContainer=s,e.FormControl=p,e.FormField=function(e){var a=e.isVisible,r=void 0===a||a,i=e.children,d=e.validate,o=e.name,u=e.placeholder,s=e.disabled,p=e.id,f=e.initalValue,v=e.pipes,y=l(),m=y.formState,h=y.setTocuhed,g=y.setDirty,F=y.setValidControl,b=y.setValidatorFn,V=y.setFormFieldAsValid,C=y.setPipesFn,S=n.default.Children.only(i),E=S.props,N="";try{N=S.type&&S.type.displayName}catch(e){N=""}var w=function(){d&&r?(b({updatedField:p,validator:d}),V({updatedField:p,isValid:!1})):V({updatedField:p,isValid:!0})};t.useEffect(function(){var e;"Datepicker"==N&&(d?null==(e=d)||e.push(c):d=[c]),w(),v&&C({updatedField:p,pipes:v}),f&&F(p,f)},[]),t.useEffect(function(){w(),r||g({updatedField:p,value:!1})},[r]);var x=function(e){e instanceof Date?e.getTime()!==f?g({updatedField:p,value:!0}):g({updatedField:p,value:!1}):g(e!==f?{updatedField:p,value:!0}:{updatedField:p,value:!1})},D=n.default.cloneElement(S,{onFocus:function(e){m.touched[p]||h({updatedField:p})},onBlur:function(e){E.onBlur&&E.onBlur(e)},onChange:function(e){var t;if(e instanceof Date)return x(e),F(p,e);x(t="string"!=typeof e&&e?e.target.value:e),F(p,t),E.onChange&&E.onChange(e)},name:o,disabled:s,id:p,value:m.values[p],selected:!m.errors[p]&&m.values[p]?new Date(m.values[p]):null,placeholder:u,error:m.errors[p]});return r?D:null},e.IsNumber=function(e){return Number.isFinite(Number(e))?null:{msg:"Should be a number"}},e.IsRequired=function(e){return e?"string"==typeof e&&""==e.trim()?{msg:"Required"}:null:{msg:"Required"}},e.ValidationMsg=v,e.allowedLength=function(e){return function(t){return t&&"string"==typeof t?t.length<e?t:t.slice(0,e):t}},e.equalLength=function(e){return function(t){return t&&"string"==typeof t&&t.length!==e?{msg:"Should contain "+e+" char"}:null}},e.isEmail=function(e){return e&&"string"==typeof e&&!e.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)?{msg:"Not a valid email"}:null},e.lenthtGreaterThan=function(e){return function(t){return t&&"string"==typeof t&&t.length<e?{msg:"Should contain at least "+e+" char"}:null}},e.numberOnly=function(e){if("string"==typeof e){var t=e.match(/\d/g);return t&&t.length?t.join(""):""}return e},e.removeSpecialChar=function(e){return"string"==typeof e?e.replace(/[^\w\s]/gi,""):e},e.toUpperCase=function(e){return"string"==typeof e?e.toLocaleUpperCase():e},e.useFormContext=f});
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 38126:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(95844),__webpack_require__(90005),__webpack_require__(27378)):0}(this,function(e,t,a,r){function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=/*#__PURE__*/o(a),n=/*#__PURE__*/o(r),s=n.default.memo(n.default.forwardRef(function(e,a){var r,o=e.placeholder,s=void 0===o?"":o,d=e.className,u=e.type,i=void 0===u?"text":u,c=e.onChange,f=e.onBlur,m=e.onFocus,p=e.value,b=e.onKeyDown,g=e.tabIndex,x=e.disabled,y=e.style,h=e.name,w=e.id,v=e.multiple,L=e.autoComplete,N=e.inputSuffix,k=e.inputPrefix,C=e.maxLength,E=e.minLength,I=e.error,T=e.rows,q=e.cols,j=e.isTextArea,B=void 0!==j&&j,D=e.mergeClasses,F=e.min,K=e.max,A=e.step,H=l.default(((r={})["mt-1 px-3 py-2 bg-white border shadow-sm block w-full rounded-md sm:text-sm text-base focus:ring-1"]=!0,r["border-grey-300  focus:outline-none \n        focus:border-brand-500 focus:ring-brand-500 "]=!I,r["border-red-500 placeholder-red-500 text-red-500"]=!!I,r[" cursor-not-allowed opacity-50"]=!!x,r["border-grey-300 placeholder-grey-600 text-grey-800"]=!I,r)),M=B?"textarea":"input",P=t.useTwMerge(H,d,D);return n.default.createElement("div",{className:"relative items-center flex w-full"},k?n.default.createElement("div",{className:"absolute left-0"},k):null,n.default.createElement(M,{ref:a,value:p||"",onChange:c,onBlur:f,onFocus:m,id:w,name:h,type:i,onKeyDown:b,disabled:x,style:y,autocomplete:L,tabIndex:g,placeholder:s,multiple:v,className:""+P,maxLength:C,minLength:E,rows:T,cols:q,min:F,step:A,max:K}),N?n.default.createElement("div",{className:"absolute right-0"},N):null)}));e.Input=s});


/***/ }),

/***/ 66579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(27378)):0}(this,function(e,t){function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=/*#__PURE__*/a(t);e.Loader=function(e){var t=e.children,a=e.loaderText;return e.isLoading?l.default.createElement("div",{"data-testid":"loader",className:"h-64 mb-5"},l.default.createElement("div",{className:"_Evws9 relative"},l.default.createElement("div",{className:"_HQGgM"},l.default.createElement("div",null)),l.default.createElement("div",{className:"_mK644"},a))):l.default.createElement(l.default.Fragment,null,t)},e.SkeletonLoader=function(e){var t=e.classNames,a=e.children,n=e.mountChildren;return e.isLoading?l.default.createElement("div",{className:"blur-md animate-pulse "+(void 0===t?"":t)},void 0===n||n?a:""):l.default.createElement(l.default.Fragment,null,a)}});


/***/ }),

/***/ 25043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,r){ true?r(exports,__webpack_require__(95844),__webpack_require__(99165),__webpack_require__(29891),__webpack_require__(27378)):0}(this,function(e,r,t,a,l){function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=/*#__PURE__*/i(l);e.ModalContainer=function(e){var i=e.isOpen,n=void 0===i||i,u=e.onClose,c=e.closeOnOutsideClick,f=void 0===c||c,s=e.children,d=e.timePeriod,y=e.override,b=e.className,m=l.useState(n),v=m[0],g=m[1];l.useEffect(function(){g(n)},[n]),l.useEffect(function(){if(d&&v)var e=setTimeout(function(){clearTimeout(e),u&&u()},d)},[v]);var w=l.useRef(null),p=r.useTwMerge("bg-white w-1/2 sm:w-11/12 rounded-xl absolute",b,y),x=r.useOnClickOutside(function(){f&&(g(!1),u&&u())});return o.default.createElement(a.Portal,{selector:"modal-root"},o.default.createElement(t.Overlay,{ref:w,onClick:function(){},isOverlay:v},o.default.createElement("div",{"data-testid":"modal",className:"justify-center items-center h-full relative ",style:v?{display:"flex"}:{display:"none"}},o.default.createElement("div",{ref:x,className:p},s))))}});


/***/ }),

/***/ 65290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,n){ true?n(exports,__webpack_require__(95844),__webpack_require__(27378),__webpack_require__(38126),__webpack_require__(90005)):0}(this,function(e,n,t,o,i){function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=/*#__PURE__*/l(t),a=/*#__PURE__*/l(i),s=n.useCreateCtx(),u=s[0],c=s[1],d={activeClasses:"",containerClasses:"",elementClasses:"",lastChildClasses:""},f=function(e,n,t,o){var i,l=e.toLocaleLowerCase().includes("all"),r=n.filter(function(e){return e});return l?(i=r,i.map(function(e){return e.toLowerCase()})).includes("all")?"":t.map(function(e){return e[o]}).join(","):r.includes(e)?r.filter(function(n){return n!==e}).join(","):[].concat(r,[e]).join(",")},p=function(e,n){var t;return null==(t=e.find(function(e){return e.value===n}))?void 0:t.label},v=function(e,n,t){return e?"label"===t?e:e.split(",").map(function(e){return p(n,e)}).join(","):""},b=function(e,n,t){return e?"label"===t?e:p(n,e)||e:""},C=r.default.forwardRef(function(e,n){var i=e.placeholder,l=void 0===i?"":i,a=e.autoComplete,s=e.inputSuffix,c=e.inputPrefix,d=e.className,f=void 0===d?"":d,p=t.useRef(null),C=u(),m=C.onFocus,g=C.setShowOptions,h=C.inputValue,w=C.optionKeyDownHandler,y=C.onChange,x=C.setFilteredOptions,O=C.options,S=C.isTypeEnabled,E=C.disableOptionFiltering,F=C.valueToChoose,L=C.filterOn;return r.default.createElement(o.Input,{ref:p,placeholder:l,name:C.name,onChange:function(e){g(!0),S&&y(e.target.value),E||x(O.filter(function(n){return n[L||"value"].toLocaleLowerCase().includes(String(e.target.value).toLocaleLowerCase())}))},disabled:C.disabled,autoComplete:a,tabIndex:3,onFocus:function(e){g(!0),m(e)},error:C.error,onKeyDown:function(e){w(e,-1)},id:C.id,value:C.isMultiSelect?v(h,O,F):b(h,O,F),inputSuffix:s,inputPrefix:c,className:f})});e.SelectContainer=function(e){var o=e.onBlur,i=void 0===o?function(){}:o,l=e.onChange,a=void 0===l?function(){}:l,s=e.onFocus,u=void 0===s?function(){}:s,d=e.isTypeEnabled,p=void 0===d||d,v=e.options,b=e.children,C=e.value,m=e.valueToChoose,g=void 0===m?"value":m,h=e.name,w=e.disabled,y=void 0!==w&&w,x=e.id,O=e.error,S=void 0!==O&&O,E=e.disableOptionFiltering,F=void 0!==E&&E,L=e.isMultiSelect,T=void 0!==L&&L,k=e.optionsVisible,V=void 0!==k&&k,j=e.className,D=void 0===j?"":j,I=e.filterOn,N=void 0===I?"value":I,K=t.useState(!1),R=K[0],q=K[1],H=t.useState(""),M=H[0],B=H[1],A=t.useState(v),P=A[0],z=A[1],U=n.useOnClickOutside(function(){R&&i(M),q(!1),z(v),V||Q(!1)}),G=t.useRef([]);t.useEffect(function(){B(C||"")},[C]);var J=t.useState(V),Q=J[1];return r.default.createElement("div",{ref:U,onClick:function(){return q(!0)},className:D},r.default.createElement(c,{value:{inputValue:M,valueToChoose:g,setInputValue:B,showOptions:J[0],setShowOptions:Q,optionsVisible:V,onChange:a,onBlur:i,onFocus:u,optionsRef:G,options:v,filteredOptions:P,disabled:y,setFilteredOptions:z,optionKeyDownHandler:function(e,n){if(G&&G.current.length){var t=G.current[n-1],o=G.current[n+1],i=G.current[0];if("ArrowUp"==e.code)t&&t.focus();else if("ArrowDown"==e.code)o?o.focus():i.focus();else if("Enter"==e.code&&n>-1){var l=F?v[n][g]:P[n][g],r=M.split(","),s=T?f(l,r,F?v:P,g):l;a(s),V||T||Q(!1)}}},error:S,name:h,id:x,isTypeEnabled:p,disableOptionFiltering:F,isMultiSelect:T,filterOn:N}},b))},e.SelectInput=C,e.SelectOptions=function(e){var n,t=e.renderCustomElement,o=e.overrideListClasses,i=e.listSuffix,l=void 0===i?null:i,s=e.onEnterCB,c=void 0===s?function(){}:s,p={activeClasses:(n=void 0===o?d:o).activeClasses||"bg-brand-200 hover:bg-brand-200",containerClasses:n.containerClasses||"rounded-b-lg max-h-32 overflow-y-auto absolute z-50 bg-white w-[95%]",elementClasses:n.elementClasses||"hover:bg-grey-200 cursor-pointer p-2 sm:py-2 sm:px-1 border border-t-0 break-all border-grey-300 sm:text-xs",lastChildClasses:n.lastChildClasses||"rounded-b-lg"},v=u(),b=v.inputValue,C=v.valueToChoose,m=v.showOptions,g=v.setShowOptions,h=v.optionsVisible,w=v.onChange,y=v.optionsRef,x=v.optionKeyDownHandler,O=v.isMultiSelect,S=v.disableOptionFiltering?v.options:v.filteredOptions,E=b?b.split(","):[];return m?r.default.createElement("ul",{className:p.containerClasses},S.map(function(e,n,o){var i,l=null==E?void 0:E.includes(e[C]),s=o.length-1===n,u=a.default(((i={})[p.elementClasses]=!0,i[p.lastChildClasses]=s,i[p.activeClasses]=l,i));return r.default.createElement("li",{ref:function(e){return y.current[n]=e},tabIndex:n+4,key:e.value+e.label+n,className:""+u,onClick:function(){return n=e,h||O||g(!1),void w(O?f(n[C],E,S,C):n[C]);var n},onKeyDown:function(t){return function(e,n,t){x(e,n),"Enter"==e.code&&c(t)}(t,n,e)}},t?t(e,n,o,l):e.label)}),l):r.default.createElement(r.default.Fragment,null)}});
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 70551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ orderDataTransformer; },
/* harmony export */   "oH": function() { return /* binding */ companyDataTransformer; },
/* harmony export */   "q2": function() { return /* binding */ priceApiTransformer; },
/* harmony export */   "ws": function() { return /* binding */ productDataTransformer; }
/* harmony export */ });
/* harmony import */ var _cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40068);
/* harmony import */ var _cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53201);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);


var priceApiTransformer = function priceApiTransformer(data) {
  return {
    taxInfo: {
      tax: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxInfo.tax', ''),
      cgst: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxInfo.cgst', ''),
      sgst: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxInfo.sgst', ''),
      igst: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxInfo.igst', '')
    },
    discount: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'discount', ''),
    referralCoupon: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'referralCoupon', false),
    couponDiscountType: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'couponDiscountType', ''),
    amountSymbol: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'amountSymbol', '₹'),
    couponDiscountValue: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'couponDiscountValue', ''),
    originalPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'originalPrice', ''),
    grossPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'grossPrice', ''),
    grossPriceWithoutTax: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'grossPriceWithoutTax', ''),
    roundedAmount: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'roundedAmount', ''),
    roundedTax: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'roundedTax', ''),
    offerPricing: {
      originalPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'offerPricing.originalPrice', ''),
      discountPercentage: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'offerPricing.discountPercentage', '')
    },
    couponCode: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'couponCode', ''),
    appliedDiscount: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'appliedDiscount', ''),
    couponDiscount: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'couponDiscount', ''),
    discountedPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'discountedPrice', ''),
    totalAmount: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'totalAmount', ''),
    listPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'listPrice', ''),
    couponError: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'couponError', ''),
    priceBreakup: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'priceBreakup', []),
    taxableDiscountTaxBreakup: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxableDiscountTaxBreakup', []),
    nonTaxableDiscountTaxBreakup: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'nonTaxableDiscountTaxBreakup', []),
    totalAmountToBePaid: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'totalAmountToBePaid', ''),
    amountPaid: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'amountPaid', '')
  };
};
var productDataTransformer = function productDataTransformer(data) {
  return {
    name: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'name', ''),
    planId: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'planId', ''),
    sku: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'sku', ''),
    gstIn: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'gstIn', ''),
    countryCode: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'countryCode', ''),
    dialCode: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'dialCode', ''),
    productServiceType: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'productServiceType', ''),
    isPayable: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'isPayable', true)
  };
};
var orderDataTransformer = function orderDataTransformer(data) {
  var a = {
    razorKey: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'razorKey', ''),
    orderID: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'orderID', ''),
    paymentGateway: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'paymentGateway', ''),
    amt: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'amt', ''),
    txnId: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'txnId', ''),
    notes: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'notes', ''),
    razorpayOrderID: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'razorpayOrderID', ''),
    juspayOrderID: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'juspayOrderID', ''),
    paymentURL: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'paymentURL', ''),
    redirectionURL: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'redirectionURL', ''),
    productServiceType: (0,_cleartax_wg_library_utils__WEBPACK_IMPORTED_MODULE_0__.getDefault)(data, 'productServiceType', '')
  };
  return a;
};
var companyDataTransformer = function companyDataTransformer(data) {
  return {
    taxpayerInfo: {
      gstin: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.gstin', ''),
      lgnm: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.lgnm', ''),
      stj: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.stj', ''),
      ctj: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.ctj', ''),
      rgdt: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.rgdt', ''),
      ctb: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.ctb', ''),
      dty: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.dty', ''),
      nba: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.nba', ''),
      sts: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.sts', ''),
      cxdt: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.cxdt', ''),
      tradeNam: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.tradeNam', ''),
      stjCd: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.stjCd', ''),
      ctjCd: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.ctjCd', ''),
      pradr: {
        addr: {
          bnm: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.bnm', ''),
          st: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.st', ''),
          loc: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.loc', ''),
          bno: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.bno', ''),
          stcd: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.stcd', ''),
          flno: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.flno', ''),
          lt: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.lt', ''),
          lg: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.lg', ''),
          dst: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.dst', ''),
          city: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.city', ''),
          pncd: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.addr.pncd', '')
        },
        ntr: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.pradr.ntr', '')
      },
      adadr: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.adadr', ''),
      frequencyType: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.frequencyType', ''),
      lstupdt: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.lstupdt', ''),
      errorMsg: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, 'taxpayerInfo.errorMsg', '')
    }
  };
};

/***/ }),

/***/ 91204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ht": function() { return /* binding */ getPriceDetails; },
/* harmony export */   "Jh": function() { return /* binding */ getReviews; },
/* harmony export */   "KL": function() { return /* binding */ getProductDetails; },
/* harmony export */   "Zu": function() { return /* binding */ postReview; },
/* harmony export */   "qi": function() { return /* binding */ getDocuments; }
/* harmony export */ });
/* harmony import */ var _config_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83718);
/* harmony import */ var _config_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57807);
/* harmony import */ var _transformer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49969);
/* harmony import */ var _transformerPricing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28022);




var getProductDetails = function getProductDetails(productId) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("plan-details/".concat(productId)).then(function (data) {
    return (0,_transformer__WEBPACK_IMPORTED_MODULE_2__/* .transformPlanDetails */ .fG)(data);
  })["catch"](function (err) {
    (0,_config_error__WEBPACK_IMPORTED_MODULE_1__/* .handleMpBackendError */ .Yv)(err);
    console.log("plan api failing for plan: ".concat(productId));
  });
};
var getPriceDetails = function getPriceDetails(planId, transformer) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("price/plans_pricing?plan_id=".concat(planId)).then(function (data) {
    return transformer ? transformer(data) : (0,_transformerPricing__WEBPACK_IMPORTED_MODULE_3__/* .transformPriceDetails */ .KG)(data);
  })["catch"](function (err) {
    (0,_config_error__WEBPACK_IMPORTED_MODULE_1__/* .handleMpBackendError */ .Yv)(err);
    return transformer ? transformer({}) : (0,_transformerPricing__WEBPACK_IMPORTED_MODULE_3__/* .transformPriceDetails */ .KG)({});
  });
};
var getDocuments = function getDocuments(productId) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("plan/".concat(productId, "/document")).then(function (data) {
    return (0,_transformer__WEBPACK_IMPORTED_MODULE_2__/* .transformDocuments */ .A2)(data);
  })["catch"](function (err) {
    (0,_config_error__WEBPACK_IMPORTED_MODULE_1__/* .handleMpBackendError */ .Yv)(err);
    console.log('document api failing');
  });
};
var getReviews = function getReviews(productId) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("plan/".concat(productId, "/reviews")).then(function (data) {
    return (0,_transformer__WEBPACK_IMPORTED_MODULE_2__/* .transformReviews */ .US)(data);
  })["catch"](function (err) {
    (0,_config_error__WEBPACK_IMPORTED_MODULE_1__/* .handleMpBackendError */ .Yv)(err);
  });
};
var postReview = function postReview(productId, review) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.post */ .LZ.post("plan/".concat(productId, "/reviews"), review).then(function (data) {
    return data;
  })["catch"](function (err) {
    (0,_config_error__WEBPACK_IMPORTED_MODULE_1__/* .handleMpBackendError */ .Yv)(err);
  });
};

/***/ }),

/***/ 49969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ transformDocuments; },
/* harmony export */   "US": function() { return /* binding */ transformReviews; },
/* harmony export */   "cy": function() { return /* binding */ transformHeaderData; },
/* harmony export */   "fG": function() { return /* binding */ transformPlanDetails; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53201);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);

var transformPlanDetails = function transformPlanDetails(planDetails) {
  return {
    active: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'active', false),
    amountSymbol: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'amountSymbol', ''),
    approvedReviewCount: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'approvedReviewCount', 0),
    companyGSTIN: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'companyGSTIN', ''),
    discountPercentage: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'discountPercentage', 0),
    faq: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'faq', []),
    inquiryNo: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'inquiryNo', ''),
    isSearchable: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'isSearchable', 0),
    listingId: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'listingId', ''),
    longDescription: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'longDescription', ''),
    metaDescription: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'metaDescription', ''),
    name: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'name', ''),
    noindex: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'noindex', false),
    ogImage: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'ogImage', ''),
    originalPrice: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'originalPrice', 0),
    payable: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'payable', false),
    planId: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'planId', ''),
    price: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'price', 0),
    priceBreakupTotal: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'priceBreakupTotal', 0),
    process: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'process', []),
    productServiceType: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'productServiceType', ''),
    productDisplayOrder: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'productDisplayOrder', 0),
    rating: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'rating', 0),
    searchable: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'searchable', false),
    seoContentBlock: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'seoContentBlock', ''),
    seoContentBlockTitle: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'seoContentBlockTitle', ''),
    seoDescription: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'seoDescription', ''),
    seoKeywords: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'seoKeywords', ''),
    seoSlug: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'seoSlug', ''),
    seoName: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'seoName', ''),
    servicesIncluded: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'servicesIncluded', []),
    shortDescription: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'shortDescription', ''),
    SKU: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'SKU', ''),
    sla: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'sla', 0),
    title: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'title', ''),
    validPriceBreakup: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'validPriceBreakup', true),
    whenRequired: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'whenRequired', []),
    whoShouldUseThis: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'whoShouldUseThis', []),
    youtubeURI: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(planDetails, 'youtubeURI', '')
  };
};
var transformDocuments = function transformDocuments(documents) {
  if (!Array.isArray(documents)) return [];
  return documents.map(function (doc) {
    return {
      id: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(doc, 'id', 0),
      externalId: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(doc, 'externalId', ''),
      name: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(doc, 'name', ''),
      description: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(doc, 'description', ''),
      imageUrl: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(doc, 'imageUrl', '')
    };
  });
};
var transformReviews = function transformReviews(reviews) {
  if (!Array.isArray(reviews)) return [];
  return reviews.map(function (review) {
    return {
      reviewerName: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(review, 'reviewerName', ''),
      reviewText: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(review, 'reviewText', ''),
      reviewRating: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(review, 'reviewRating', '')
    };
  });
};
var transformHeaderData = function transformHeaderData(header) {
  if (!Array.isArray(header)) return [];
  return header.map(function (category) {
    var subMenu = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(category, 'subMenu', []);

    if (Array.isArray(subMenu)) {
      subMenu = transformHeaderData(subMenu);
    } else {
      subMenu = [];
    }

    return {
      categoryId: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(category, 'categoryId', ''),
      seoSlug: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(category, 'seoSlug', ''),
      name: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(category, 'name', ''),
      description: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(category, 'description', ''),
      categoryDisplayOrder: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(category, 'categoryDisplayOrder', 0),
      subMenu: subMenu
    };
  });
};

/***/ }),

/***/ 28022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KG": function() { return /* binding */ transformPriceDetails; },
/* harmony export */   "YY": function() { return /* binding */ transformPricingToObj; },
/* harmony export */   "i7": function() { return /* binding */ transformPricingToObjWName; }
/* harmony export */ });
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90849);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53201);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _checkout_api_checkout_tranformer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70551);
/* harmony import */ var _p_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7784);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var transformPriceDetails = function transformPriceDetails(pricingPlans) {
  var originalPrice = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'planDetails', 'offerPricing', 'originalPrice'], 0);
  var totalAmount = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'planDetails', 'pricing', 'totalAmount'], 0);
  var tax = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'planDetails', 'pricing', 'tax'], 0);
  return {
    externalId: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'externalId'], ''),
    planName: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'planDetails.name'], ''),
    originalPrice: Math.floor(originalPrice),
    totalAmount: Math.floor(totalAmount),
    discountPercentage: (0,_p_utils__WEBPACK_IMPORTED_MODULE_3__/* .getPercentageDiff */ .p)(originalPrice, totalAmount),
    tax: Math.floor(tax),
    listPrice: Math.floor(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'planDetails', 'price'], 0)),
    servicesIncluded: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(pricingPlans, ['0', 'planDetails', 'servicesIncluded'], [])
  };
};
var transformPricingToObj = function transformPricingToObj(pricingPlans) {
  if (pricingPlans && pricingPlans.length) {
    return pricingPlans.reduce(function (sum, ele) {
      var couponCode = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'autoApplicableCoupon.code', '');
      var couponDiscount = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'autoApplicableCoupon.discountValue', '');
      var planDetails = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails', {});
      var pricing = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.pricing', {});
      return _objectSpread(_objectSpread({}, sum), {}, (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, String(ele.externalId), (0,_checkout_api_checkout_tranformer__WEBPACK_IMPORTED_MODULE_2__/* .priceApiTransformer */ .q2)(_objectSpread(_objectSpread(_objectSpread({}, planDetails), pricing), {}, {
        couponDiscount: couponDiscount,
        couponCode: couponCode
      }))));
    }, {});
  }

  return {};
};
var transformPricingToObjWName = function transformPricingToObjWName(pricingPlans) {
  if (pricingPlans && pricingPlans.length) {
    return pricingPlans.reduce(function (sum, ele) {
      return _objectSpread(_objectSpread({}, sum), {}, (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, String(ele.externalId), {
        externalId: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'externalId', ''),
        originalPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.offerPricing.originalPrice', ''),
        totalAmount: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.pricing.totalAmount', ''),
        discountPercentage: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.offerPricing.discountPercentage', ''),
        tax: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.pricing.tax', ''),
        planName: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.name', ''),
        listPrice: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(ele, 'planDetails.price', 0)
      }));
    }, {});
  }

  return {};
};

/***/ }),

/***/ 38266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ usePlanCtx; },
/* harmony export */   "p": function() { return /* binding */ PlanDetailsProvider; }
/* harmony export */ });
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97865);
/* harmony import */ var _cleartax_wg_library_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95844);



// eslint-disable-next-line react-hooks/rules-of-hooks
var _useCreateCtx = (0,_cleartax_wg_library_hooks__WEBPACK_IMPORTED_MODULE_0__.useCreateCtx)(),
    _useCreateCtx2 = (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_useCreateCtx, 2),
    usePlanCtx = _useCreateCtx2[0],
    PlanDetailsProvider = _useCreateCtx2[1];



/***/ }),

/***/ 7784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ getPercentageDiff; },
  "F": function() { return /* binding */ renderStickyBar; }
});

// EXTERNAL MODULE: ../mp-library/packages/components/button/dist/index.js
var dist = __webpack_require__(54858);
// EXTERNAL MODULE: ../mp-library/packages/components/conditionals/dist/index.js
var conditionals_dist = __webpack_require__(90928);
// EXTERNAL MODULE: ../mp-library/packages/components/loader/dist/index.js
var loader_dist = __webpack_require__(66579);
// EXTERNAL MODULE: ../mp-library/packages/components/typography/dist/index.js
var typography_dist = __webpack_require__(78541);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(80144);
// EXTERNAL MODULE: ./src/shared/index.ts + 5 modules
var shared = __webpack_require__(25338);
// EXTERNAL MODULE: ./src/shared/utils/utils/index.tsx
var utils = __webpack_require__(87353);
// EXTERNAL MODULE: ./src/pages/services/[planSeoSlug]/p/planDetailsContext.tsx
var planDetailsContext = __webpack_require__(38266);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/components/page-sections/sticky-price-card/index.tsx











var StickyPriceCard = function StickyPriceCard() {
  var _usePlanCtx = (0,planDetailsContext/* usePlanCtx */.U)(),
      seoSlug = _usePlanCtx.seoSlug,
      name = _usePlanCtx.name,
      amountSymbol = _usePlanCtx.amountSymbol,
      listingId = _usePlanCtx.listingId,
      getPlanPriceDetailsApi = _usePlanCtx.getPlanPriceDetailsApi;

  var _getPlanPriceDetailsA = getPlanPriceDetailsApi.data,
      totalAmount = _getPlanPriceDetailsA.totalAmount,
      tax = _getPlanPriceDetailsA.tax,
      originalPrice = _getPlanPriceDetailsA.originalPrice;
  var discountedPrice = totalAmount - tax;
  var discountPercentage = getPercentageDiff(originalPrice, discountedPrice);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      boxShadow: '0px 5.00421px 5.00421px rgba(0, 0, 0, 0.1)'
    },
    className: "w-full bg-grey-100 flex items-center h-32 rounded-3xl sticky bottom-0.5 sm:h-auto sm:py-5 sm:bottom-0",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wg-container w-full flex justify-between items-center sm:flex-col",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-1/2 sm:w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          textSize: "2xl",
          className: "text-brand-1000 w-full sm:text-s-14 sm:font-semibold",
          weight: "bold",
          children: name
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex w-1/2 justify-end items-center sm:w-full sm:justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pr-8 sm:flex sm:pr-0 sm:items-center w-1/3 sm:w-1/2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(loader_dist.SkeletonLoader, {
            isLoading: getPlanPriceDetailsApi.isLoading,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
              textSize: "4xl",
              className: "text-brand-1000 pt-4 sm:text-s-20 sm:pt-0 sm:pr-2 whitespace-nowrap",
              weight: "bold",
              children: !getPlanPriceDetailsApi.isLoading ? "".concat((0,utils/* getCurrencyFromUnicode */._X)(amountSymbol)).concat((0,utils/* getCommaFormat */.pi)(discountedPrice)) : '$1,000'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(loader_dist.SkeletonLoader, {
            isLoading: getPlanPriceDetailsApi.isLoading,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex pt-2 items-center text-center justify-center sm:pt-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(conditionals_dist.If, {
                condition: !!originalPrice,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
                  className: "text-grey-700 line-through decoration-red-600 whitespace-nowrap",
                  children: !getPlanPriceDetailsApi.isLoading ? "".concat((0,utils/* getCurrencyFromUnicode */._X)(amountSymbol), "\n                      ").concat((0,utils/* getCommaFormat */.pi)(originalPrice)) : '$1,000'
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
                  weight: "extrabold",
                  className: "text-red-600 pl-2 whitespace-nowrap",
                  children: "(".concat(discountPercentage, "% OFF)")
                })]
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_dist.Text, {
          type: "a",
          textSize: "lg",
          href: "".concat(constants/* CLEARTAX_DOMAIN */.nX, "/checkout/").concat(listingId),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist.Button, {
            variant: "blue",
            rounded: "lg",
            className: "px-12 py-5 sm:text-base sm:px-5 sm:py-1",
            onClick: function onClick() {
              (0,shared/* trackAction */.X2)('click', '', {
                label: "buy_now_sticky_bottom_product_page_".concat(seoSlug)
              });
            },
            children: "Buy now"
          })
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/services/[planSeoSlug]/p/utils/index.tsx



var renderStickyBar = function renderStickyBar(ref, visible) {
  if (!ref.current) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return visible ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(StickyPriceCard, {});
};
var getPercentageDiff = function getPercentageDiff(a, b) {
  if (isNaN(a) || isNaN(b) || !a) return 0;
  return Math.floor((1 - b / a) * 100);
};

/***/ }),

/***/ 21267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getStatesApi; },
/* harmony export */   "Y": function() { return /* binding */ getCountryApi; }
/* harmony export */ });
/* harmony import */ var _config_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83718);

var getCountryApi = function getCountryApi() {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get('country/code').then(function (data) {
    return data;
  })["catch"](function () {
    return [];
  });
};
var getStatesApi = function getStatesApi(planId) {
  return _config_axios__WEBPACK_IMPORTED_MODULE_0__/* .mpBackend.get */ .LZ.get("states?planId=".concat(planId)).then(function (data) {
    return data;
  })["catch"](function () {
    return [];
  });
};

/***/ }),

/***/ 25338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ds": function() { return /* reexport */ utils/* debounce */.Ds; },
  "Tt": function() { return /* reexport */ utils/* getApiParamsString */.Tt; },
  "pi": function() { return /* reexport */ utils/* getCommaFormat */.pi; },
  "_X": function() { return /* reexport */ utils/* getCurrencyFromUnicode */._X; },
  "bt": function() { return /* reexport */ utils/* postLeadsToFinfo */.bt; },
  "Uy": function() { return /* reexport */ utils/* productFromProctServiceType */.Uy; },
  "lv": function() { return /* reexport */ utils/* randomIntFromInterval */.lv; },
  "X2": function() { return /* reexport */ utils/* trackAction */.X2; }
});

// UNUSED EXPORTS: getAuthenticationStatus, getCountryApi, getCurrentFiscalYear, getDateDiffInDays, getDateDiffInHours, getPageLoader, getStatesApi, resolveServerSideProps, throttle, withAuth

// EXTERNAL MODULE: ./src/config/axios.ts
var axios = __webpack_require__(83718);
// EXTERNAL MODULE: ../node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(53201);
;// CONCATENATED MODULE: ./src/shared/context/user/utils/user.transformer.ts

var user_transformer_userTransformer = function userTransformer(user) {
  return {
    username: get(user, 'username', ''),
    externalId: get(user, 'externalId', ''),
    isLoggedIn: get(user, 'isLoggedIn', false),
    role: get(user, 'role', 'SERVICE_PROVIDER')
  };
};
;// CONCATENATED MODULE: ./src/shared/api/auth.api.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var auth_api_getAuthenticationStatus = function getAuthenticationStatus(cookie) {
  return mpBackend.get('user/isAuthenticated', {
    headers: {
      Cookie: cookie
    }
  }).then(function (data) {
    return userTransformer(_objectSpread(_objectSpread({}, data.response), {}, {
      isLoggedIn: true
    }));
  })["catch"](function () {
    return userTransformer({});
  });
};
// EXTERNAL MODULE: ./src/shared/api/country.api.ts
var country_api = __webpack_require__(21267);
;// CONCATENATED MODULE: ./src/shared/api/index.ts
/* istanbul ignore file */


// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34707);
// EXTERNAL MODULE: ../node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(29194);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(80144);
;// CONCATENATED MODULE: ./src/shared/hoc/withAuth.ts
/* provided dependency */ var Buffer = __webpack_require__(30816)["lW"];





/**
  WithAuth will hit mp-backend authentication api if isLoggedIn 
  is false will redirect to sso with return path as current path
*/

/**
auth-failed-retry cookie is used as fail safe to prevent website from getting 
into a recursive loop
For example /checkout/prod-itr ----> will hit backend(mp-backend) and this fails 
it will send the request to sso as a return path is /checkout/prod-itr after login 
this request will again comeback to /checkout/prod-itr as mp-backend is down this will
fail again and will create a loop

To protect it from going into infinite loop we have used auth-failed-retry cookie which will
try for 3 times else will send this to home page
 */

var COOKIE_MAX_AGE = (/* unused pure expression or super */ null && (60 * 6 * 24));
var RETRY_ATTEMPTS = 3; // eslint-disable-next-line @typescript-eslint/ban-types

function withAuth(cb) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
      var req, res, authFailedRetries, auth, returnPath;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              req = ctx.req, res = ctx.res;
              authFailedRetries = getCookie('auth-failed-retry', ctx);

              if (!(!authFailedRetries || parseInt(authFailedRetries) < RETRY_ATTEMPTS)) {
                _context.next = 15;
                break;
              }

              _context.next = 5;
              return getAuthenticationStatus(req.headers.cookie);

            case 5:
              auth = _context.sent;
              returnPath = Buffer.from(req.url).toString('base64');

              if (!(!auth || auth && !auth.isLoggedIn)) {
                _context.next = 12;
                break;
              }

              setCookie('auth-failed-retry', authFailedRetries ? parseInt(authFailedRetries) + 1 : 1, {
                req: req,
                res: res,
                maxAge: COOKIE_MAX_AGE
              });
              return _context.abrupt("return", {
                redirect: {
                  destination: "".concat("https://accounts.cleartax.in/v2?product=cleartax", "&return_path=").concat(returnPath),
                  permanent: false
                }
              });

            case 12:
              return _context.abrupt("return", cb(ctx, auth));

            case 13:
              _context.next = 17;
              break;

            case 15:
              setCookie('auth-failed-retry', 0, {
                req: req,
                res: res,
                maxAge: COOKIE_MAX_AGE
              });
              return _context.abrupt("return", NEXT_REDIRECT_OBJECT_HOMEPAGE);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
;// CONCATENATED MODULE: ./src/shared/hoc/index.ts
/* istanbul ignore file */

// EXTERNAL MODULE: ./src/shared/utils/index.ts + 3 modules
var utils = __webpack_require__(47174);
;// CONCATENATED MODULE: ./src/shared/index.ts
/* istanbul ignore file */




/***/ })

}]);